module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_3-759fae25d0ae06e2a3935c10af8fbf72.jpg";